import { jsx } from "react/jsx-runtime";
import react from "react";
const myTripContextData = /*#__PURE__*/ react.createContext({
    currentTrips: [],
    upcomingTrips: [],
    pastTrips: [],
    canceledTrips: [],
    deepLinkPrompt: '',
    hasMoreTrips: false,
    displayInRealtimeVoice: false,
    submitChatMessageInMarkerComponent: void 0
});
const MyTripDataProvider = ({ children, currentTrips, upcomingTrips, pastTrips, canceledTrips, deepLinkPrompt = '', hasMoreTrips = false, displayInRealtimeVoice = false, submitChatMessageInMarkerComponent })=>/*#__PURE__*/ jsx(myTripContextData.Provider, {
        value: {
            currentTrips,
            upcomingTrips,
            pastTrips,
            canceledTrips,
            deepLinkPrompt,
            hasMoreTrips,
            displayInRealtimeVoice,
            submitChatMessageInMarkerComponent
        },
        children: children
    });
export { MyTripDataProvider, myTripContextData };
